import { z } from 'zod/v4-mini';

import { GeneralBackendResponseSchema } from '$/services/mapper/authentication';
import { ProjectFolderSchema } from '$/services/usecases/projects/mapper/editorProject';
import { ProjectOverviewItemSchema } from '$/services/usecases/projects/mapper/projectOverview';

export const SchoolClassSchema = z.object({
  id: z.string(),
  name: z.string(),
  schoolId: z.string(),
  teacherId: z.string(),
  studentIds: z._default(z.array(z.string()), []),
});

export type SchoolClass = z.infer<typeof SchoolClassSchema>;

export const GetAllSchoolClassesResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.array(SchoolClassSchema),
});

export const GetSchoolClassByIdResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: SchoolClassSchema,
});

export const UpsertSchoolClassResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: SchoolClassSchema,
});

export const GetSchoolClassProjectsResponseSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.object({
    projects: z.array(ProjectOverviewItemSchema),
    folders: z.array(ProjectFolderSchema),
    schoolClass: SchoolClassSchema,
  }),
});
